import React, { useEffect, useState } from "react";
import handlerImage from "../../assets/handler1.png";

const SouthEastArrow = () => {
  const [isLightMode, setIsLightMode] = useState(
    document.documentElement.getAttribute("data-theme") === "light"
  );
  useEffect(() => {
    const handleThemeChange = () => {
      const currentTheme = document.documentElement.getAttribute("data-theme");
      setIsLightMode(currentTheme === "light");
    };

    // Listen for the 'storage' event triggered by ThemeSwitch
    window.addEventListener("storage", handleThemeChange);

    // Clean up listener on unmount
    return () => {
      window.removeEventListener("storage", handleThemeChange);
    };
  }, []);
  return isLightMode ? (
    <svg
      width="20px"
      height="20px"
      version="1.1"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      style={{ fill: "#d1d3d4" }}
    >
      <path d="M14.2,16.2c-.6,0-1-.4-1-1,0-.3.1-.5.3-.7l1-1c.4-.4,1-.4,1.4,0,.4.4.4,1,0,1.4h0l-1,1c-.2.2-.4.3-.7.3h0ZM8.6,16.2c-.6,0-1-.4-1-1,0-.3.1-.5.3-.7l6.6-6.6c.4-.4,1-.4,1.4,0,.4.4.4,1,0,1.4h0l-6.6,6.6c-.2.2-.4.3-.7.3h0ZM2.8,16.2c-.6,0-1-.4-1-1,0-.3.1-.5.3-.7L14.5,2c.4-.4,1-.4,1.4,0,.4.4.4,1,0,1.4L3.5,15.9c-.2.2-.4.3-.7.3Z" />
    </svg>
  ) : (
    <img
      src={handlerImage}
      alt="Resize handle"
      style={{
        width: "20px",
        height: "20px",
        cursor: "nwse-resize",
      }}
    />
  );
};

const CustomHandle = (props) => {
  return (
    <div
      style={{
        // background: "#fff",
        // backgroundColor: isLightMode ? "white" : "#111218",
        borderRadius: "2px",
        // border: "1px solid #ddd",
        position: "absolute",
        bottom: 1,
        right: 2,
        padding: 0,
        cursor: "se-resize",
      }}
      {...props}
    />
  );
};

const BottomRightHandle = () => (
  <CustomHandle>
    <SouthEastArrow />
  </CustomHandle>
);

export default BottomRightHandle;
